import { PermissionsConstants, Selector } from 'src/common/types';
import DataStore, { Query, QueryResult } from 'src/core/stores/data-store';

export interface PermissionSummary {
  id: string;
  name: string;
  description: string;
  selector: Selector;
}

const hiddenPermissions = [PermissionsConstants.UseStructMaster];

export const permissionIsHidden = (permission: PermissionsConstants) => {
  return hiddenPermissions.includes(permission);
};

export class PermissionSummaryStore extends DataStore<PermissionSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/permissions`, []);
  }

  public async loadPermissions(query: Partial<Query>) {
    return (
      (await this.handleCallAsync(async () => {
        var response = await this.httpService.get<QueryResult<PermissionSummary>>(`${this.baseUrl}?${DataStore.buildUrl(query as Query)}`);
        this._state.set((s) => {
          s.items = response.data.items || [];
          s.count = response.data.count || 0;
          return s;
        });
        return response.data.items;
      })) ?? []
    );
  }
}
